import {
    ResourceAllocationState,
    ResourceProjectAssignment
} from '../../../types';
import {removeAssignmentCascade} from '../cascadeDelete';

export const assignmentHandlers = {
    AssignmentAdded: (
        state: ResourceAllocationState,
        data: ResourceProjectAssignment
    ): ResourceAllocationState => {
        return {
            ...state,
            assignments: {...state.assignments, [data.id]: data}
        };
    },
    AssignmentUpdated: (
        state: ResourceAllocationState,
        data: {id: string; updates: Partial<ResourceProjectAssignment>}
    ): ResourceAllocationState => {
        const next = {
            ...state,
            assignments: {
                ...state.assignments,
                [data.id]: {
                    ...state.assignments[data.id],
                    ...data.updates
                }
            }
        };
        // Reclassification cascades to child allocations server-side (their
        // denormalised `type` is what the calc engine reads) — mirror it.
        // Involvement is denormalised at read time (no server-side row update),
        // so this local cascade is the ONLY thing keeping loaded allocations fresh.
        const newType = data.updates.allocationType;
        const newInvolvement = data.updates.involvement;
        if (newType !== undefined || newInvolvement !== undefined) {
            next.allocations = Object.fromEntries(
                Object.entries(state.allocations).map(([allocId, alloc]) => {
                    if (alloc.assignmentId !== data.id) {
                        return [allocId, alloc];
                    }
                    const cascaded = {...alloc};
                    if (newType !== undefined) {
                        cascaded.type = newType;
                    }
                    if (newInvolvement !== undefined) {
                        cascaded.involvement = newInvolvement;
                    }
                    return [allocId, cascaded];
                })
            );
        }
        return next;
    },
    AssignmentDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        // Mirror the DB cascade: also prune this assignment's allocations.
        return removeAssignmentCascade(state, data.id);
    }
};
